// src/features/vehicle/vehicleSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedVehicle: null, 
  editDocuments: null,
  listRefresh: false,
};

const vehicleSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    setVehicle: (state, action) => {
      state.selectedVehicle = action.payload;
    },
    setListRefresh: (state) => {
      state.listRefresh = !state.listRefresh;
    },
    setEditDoc: (state, action) => {
      state.editDocuments = action.payload;
    },
    clearEditDoc: (state) => {
      state.editDocuments = null;
    },
  },
});

export const { setVehicle, setListRefresh, setEditDoc, clearEditDoc } = vehicleSlice.actions;
export default vehicleSlice.reducer;
